(function () {
  'use strict';

  const RESET_DELAY = 2000;

  class CopyButton {
    constructor() {
      this.timers = new WeakMap();
      this.onClick = this.onClick.bind(this);
      this.init();
    }

    copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          document.execCommand('copy');
          resolve();
        } catch (err) {
          reject(err);
        } finally {
          document.body.removeChild(textarea);
        }
      });
    }

    showFeedback(button, wrap) {
      const label = button.querySelector('.button__text');
      if (!label) return;

      if (!button.classList.contains('is-copied')) {
        button.dataset.originalLabel = label.textContent;
      }

      const copiedLabel = wrap.dataset.copiedLabel;
      if (copiedLabel) label.textContent = copiedLabel;
      button.classList.add('is-copied');

      window.clearTimeout(this.timers.get(button));
      this.timers.set(
        button,
        window.setTimeout(() => {
          label.textContent = button.dataset.originalLabel;
          button.classList.remove('is-copied');
        }, RESET_DELAY)
      );
    }

    onClick(e) {
      const button = e.target.closest('.js-copy-button');
      if (!button) return;

      const wrap = button.closest('.js-copy-button-wrap');
      if (!wrap) return;

      const text = wrap.dataset.copyText;
      if (!text) return;

      e.preventDefault();

      this.copyText(text).then(() => {
        this.showFeedback(button, wrap);
      });
    }

    destroy() {
      document.removeEventListener('click', this.onClick);
    }

    init() {
      document.addEventListener('click', this.onClick);
    }
  }

  window.Universe.CopyButton = CopyButton;
})();
